import {getSliders} from "../../api/mainpage/topSection";
// import {getNew} from "../../api/news";

const state = () => ({
  slider : {
    imgPath: '',
    title:'',
    text:'',
    buttonText:'',
    buttonLink:''
  },
  lastSlider:[],
  newsId: null
})


const getters = {
  get_slider(state) {
    return state.lastSlider;
  },
}

const mutations = {
  SET_SLIDER(state,data){
    state.lastSlider = data;}
}

const actions = {
  async fetchSlider({ commit }) {
    try {
      const response = await getSliders();
      commit('SET_SLIDER', response.data);
    } catch (error) {
      // handle the error here
    }
  },

}




export  default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
